import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmprojectposition/cecUnmProjectPosition/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmprojectposition/cecUnmProjectPosition/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmprojectposition/cecUnmProjectPosition/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/unmprojectposition/cecUnmProjectPosition/list',
      method: 'get',
      params: params
    })
  },
  allList: function (params) {
    return request({
      url: '/unmprojectposition/cecUnmProjectPosition/allList',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmprojectposition/cecUnmProjectPosition/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmprojectposition/cecUnmProjectPosition/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmprojectposition/cecUnmProjectPosition/import',
      method: 'post',
      data: data
    })
  },

  getCecUpdatePosition: function (params) {
    return request({
      url: '/unmprojectposition/cecUnmProjectPosition/getCecUpdatePosition',
      method: 'post',
      params: params
    })
  }
}
